import React, { useState } from "react";
import axios from "axios";
import { API } from "../App";
import { QRCodeSVG } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { QrCode, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { useAppSettings } from "../context/AppSettingsContext";

const LessonQRCode = ({ lessonId, lessonTitle }) => {
  const [open, setOpen] = useState(false);
  const [checkinData, setCheckinData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const { getAppUrl } = useAppSettings();

  const handleOpen = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/lessons/${lessonId}/checkin-code`, { withCredentials: true });
      setCheckinData(res.data);
      setOpen(true);
    } catch {
      toast.error("Erro ao gerar código QR");
    } finally {
      setLoading(false);
    }
  };

  const handleCopyCode = () => {
    if (checkinData?.checkin_code) {
      navigator.clipboard.writeText(checkinData.checkin_code);
      setCopied(true);
      toast.success("Código copiado!");
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const checkinUrl = checkinData ? getAppUrl(`/checkin/${checkinData.checkin_code}`) : "";

  return (
    <>
      <Button size="sm" variant="outline" onClick={handleOpen} disabled={loading} data-testid={`qr-btn-${lessonId}`}>
        <QrCode className="mr-1 h-4 w-4" /> QR
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle className="text-center text-[#3d5a63]">Código de Presença</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col items-center space-y-4 py-4">
            <h3 className="font-semibold text-[#3d5a63]">{lessonTitle}</h3>
            {checkinData && (
              <>
                <p className="text-sm text-[#94A3B8]">{checkinData.date} — {checkinData.start_time}</p>
                
                {/* QR Code */}
                <div className="bg-white p-4 rounded-2xl shadow-inner border border-slate-100" data-testid="qr-code">
                  <QRCodeSVG value={checkinUrl} size={180} level="M" includeMargin />
                </div>
                
                {/* Code display with copy */}
                <div className="w-full bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <p className="text-xs text-[#94A3B8] mb-2 text-center">Código para inserir manualmente:</p>
                  <div className="flex items-center justify-center gap-2">
                    <span className="font-mono font-bold text-2xl text-[#3d5a63] tracking-[0.3em]" data-testid="checkin-code-display">
                      {checkinData.checkin_code.toUpperCase()}
                    </span>
                    <Button 
                      size="sm" 
                      variant="ghost" 
                      onClick={handleCopyCode}
                      className="h-8 w-8 p-0"
                      data-testid="copy-code-btn"
                    >
                      {copied ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4 text-[#94A3B8]" />}
                    </Button>
                  </div>
                </div>
                
                <p className="text-xs text-[#94A3B8] text-center max-w-[260px]">
                  Os alunos podem digitalizar o QR ou inserir o código manualmente no dashboard
                </p>
              </>
            )}
          </div>
          <DialogClose asChild>
            <Button variant="outline" className="w-full">Fechar</Button>
          </DialogClose>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LessonQRCode;
